export const config = {
    apiUrl: 'http://127.0.0.1:8000'
}
